export enum Constants {
  CURRENT_USER = 'currentUser',
  SELECTED_ROLE = 'selectedRole',
  ORG_SETTINGS = 'orgSettings',
  SQUARE = 'Square',
  CLOVER = 'Clover',
  DINE_IN = 'Dine In',
  CARRYOUT = 'Carryout',
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  REWARDS = 'REWARDS',
  SERVER = 'Server',
  CASHIER = 'Cashier',
  TABLE = 'Table',
  KIOSK = 'Kiosk',
  ORDERS_DISPLAY = 'OrdersDisplay',
  CONFIRMATION_DISPLAY = 'ConfirmationDisplay',
  QR_ORDER = 'QROrder',
  JUKEBOX = 'Jukebox',
  NO_ACCESS = 'NoAccess',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  READY = 'READY',
  DRAFT = 'DRAFT',
  MAINVIEW = 'Main',
  SPLIT_VIEW = 'Split',
  CLASSIC_VIEW = 'NoNav',
  WEBSITE = 'Website',
  THEME = 'Theme',
  CUSTOMER = 'Customer',
  FANFAVORITES = 'fanFavorites',
  DELIVERY = 'Delivery',
  DINENGO = 'DINENGO',
  UBER_EATS = 'Uber Eats',
  DOORDASH = 'DoorDash',
  GRUBHUB = 'Grubhub'
}
